// Valence + arousal sliders, shared by PreSurveyScreen and PostSurveyScreen.
// Large touch targets and big numerals — designed for older adults (Section 10).

const VALENCE_LABELS = ['Very negative', 'Negative', 'Neutral', 'Positive', 'Very positive'];
const AROUSAL_LABELS = ['Exhausted', 'Low energy', 'Neutral', 'Energetic', 'Very energetic'];

function Slider({ label, endpoints, value, onChange }) {
  return (
    <div className="card">
      <p className="font-display text-lg mb-4">{label}</p>
      <div className="flex items-center justify-between gap-3">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => onChange(n)}
            aria-pressed={value === n}
            aria-label={`${label}: ${n} of 5`}
            className={`min-h-touch flex-1 rounded-full border text-lg font-semibold transition
              ${
                value === n
                  ? 'bg-amber text-ink border-amber'
                  : 'bg-panel text-paper border-hairline active:bg-raised'
              }`}
          >
            {n}
          </button>
        ))}
      </div>
      <div className="flex justify-between mt-2 text-xs text-dim">
        <span>{endpoints[0]}</span>
        <span>{endpoints[1]}</span>
      </div>
    </div>
  );
}

export default function AffectSurvey({ valence, arousal, onValenceChange, onArousalChange }) {
  return (
    <div className="flex flex-col gap-5">
      <Slider
        label="How is your mood right now?"
        endpoints={['Negative', 'Positive']}
        value={valence}
        onChange={onValenceChange}
      />
      <Slider
        label="How much energy do you feel?"
        endpoints={['Exhausted', 'Energetic']}
        value={arousal}
        onChange={onArousalChange}
      />
    </div>
  );
}

export { VALENCE_LABELS, AROUSAL_LABELS };
